import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import amaxLogo from "../../images/amaxLogoWhite.png";
import API_URL from "../../api/API";
import { useAthleteLogin } from "./useAthleteLogin";

export const AthleteLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { athleteLogin, error, isLoading } = useAthleteLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await athleteLogin(email, password);
  };

  return (
    <div className="p-[20px] bg-white h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-10 overflow-y-auto pt-16">
        <Link to="/" className="size-[96px] xs:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>
        <div className="w-full flex flex-col gap-5 xs:gap-7">
          <div className="flex flex-col gap-3.5">
            <p className="text-black text-3xl xs:text-4xl leading-tight font-light pb-3 xs:pb-6">
              Sign in <br />
              <span className="text-4xl xs:text-5xl leading-tight font-bold">ATHLETE.</span>
            </p>

            {/* Display Error Message */}
            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

            {/* Display Loading Indicator */}
            {isLoading && ( 
              <p className="text-yellow-500 text-sm mt-2">
                Processing request please wait...
              </p>
            )}
            <form action="" className="flex flex-col gap-5 xs:gap-7">
              <input
                type="email"
                className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                placeholder="Email"
                value={email}
                onChange={(element) => setEmail(element.target.value)}
              />
              <input
                type="password"
                className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                placeholder="Password"
                value={password}
                onChange={(element) => setPassword(element.target.value)}
              />
            </form>

            <button
              onClick={handleSubmit}
              className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300 mt-5 xs:mt-10"
            >
              SIGN IN
            </button>

            <Link
              to="/athlete/forgot-password"
              className="w-fit text-sm xs:text-base font-light text-black hover:text-black/70 transition-all duration-300 text-end inline-block ml-auto mr-3"
            >
              Forgot password
            </Link>
          </div>
        </div>
        <div className="w-full flex flex-col gap-3.5">
          <Link
            to="/athlete/register/step1"
            className="w-fit text-sm xs:text-base font-light text-black hover:text-black/70 transition-all duration-300 text-start inline-block ml-3"
          >
            Not a Member?
          </Link>
          <Link to="/athlete/register/step1">
            <button className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300">
              JOIN US
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
